<template>
  <div>
    <Card shadow>
      <Row :gutter="18" style="margin-top: 10px">
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">包网信息:</span>
            <Select v-model="select.type" placeholder="筛选包网信息" clearable>
              <Option
                v-for="item in select.type_List"
                :value="item.value"
                :key="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">投注类型:</span>
            <Select
              v-model="select.bet_type"
              placeholder="筛选投注类型"
              clearable
            >
              <Option
                v-for="item in select.tz_list"
                :value="item.value"
                :key="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">流水单号:</span>
            <Input
              v-model.trim="table.params.order_no"
              placeholder="请输入流水单号"
              clearable
            ></Input>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">选择日期:</span>
            <DatePicker
              type="date"
              format="yyyy-MM-dd"
              v-model="select.dataTime1"
              placeholder="选择日期"
              :clearable="false"
            ></DatePicker>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">时间范围:</span>
            <TimePicker
              type="timerange"
              confirm
              v-model="select.dataTime2"
              placeholder="选择时间范围"
              :clearable="false"
            ></TimePicker>
          </label>
        </Col>
        <Col span="1">
          <Button
            type="primary"
            :loading="loading"
            @click="getList()"
            :disabled="!table.params.order_no"
          >
            <span v-if="!loading">查询</span>
            <span v-else>loading..</span>
          </Button>
        </Col>
      </Row>
      <Row :gutter="18" style="margin-top: 10px">
        <Col span="3">
          <span style="line-height: 33px">
            变动金额：{{ (table.sum / 10000).toFixed(2) }}</span
          >
        </Col>
        <Col span="3">
          <span style="line-height: 33px"> 记录数量：{{ table.total }}</span>
        </Col>
      </Row>
    </Card>

    <Table
      style="margin-top: 10px"
      :max-height="350"
      border
      size="large"
      :columns="table.columns"
      :data="getTableShowData()"
      @on-column-width-resize="widthResize"
    ></Table>

    <!-- 变更详情 -->
    <Modal v-model="optTypeModal.show" :width="getTableWidth()">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>变更详情</span>
      </p>
      <!-- <optTable :sourcenum="optTypeModal.sourcenum" :listdata="optTypeModal.list" :opttype="optTypeModal.opttypename"></optTable> -->
      <allTable
        :sourcenum="optTypeModal.sourcenum"
        :listdata="optTypeModal.list"
        :opttype="optTypeModal.opttypename"
      ></allTable>
    </Modal>
  </div>
</template>
<script>
import { TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
import { getTableSetting, setTableSetting } from '@/libs/util'
import { tableSettingModel } from '@/libs/config'
import allTable from './components/allTable.vue'
export default {
  name: 'UserPointRecord',
  components: { allTable },
  data() {
    return {
      loading: false,
      TransTopReqTimer: null,
      tableSetting: {},
      select: {
        bet_type: null,
        type: null,
        game_List: [],
        dataTime1: this.getCurrentZeroDay(),
        dataTime2: ['00:00:00', '23:59:59'],
        dataTime: [
          this.getCurrentZeroDay(),
          new Date(new Date().setHours(23, 59, 59, 59))
        ],
        type_List: [
          { value: 1, name: '外部包网' },
          { value: 0, name: '内部包网' },
          { value: 2, name: '合作包网' }
        ],
        tz_list: [
          { value: 3, name: '投注支出' },
          { value: 4, name: '投注收益' }
        ]
      },
      //变更详情
      optTypeModal: {
        game_id: '',
        opttypename: '',
        show: false,
        list: [],
        sourcenum: ''
      },
      //表格数据
      table: {
        name: '0',
        list: [],
        params1: {},
        params: {
          platform: 0,
          app_id: 0,
          game_id: 0,
          stime: 0,
          etime: 0,
          user_id: '',
          ip: '',
          order_no: '',
          ext: '',
          nosource_type: [],
          pack_no: -1,
          source_type: [],
          page: 1,
          limit: 1000
        },
        pageSizes: [15, 30, 45, 60],
        app_ids: [],
        data: [],
        columns: [
          { type: 'index', title: '序号', width: 40, align: 'center' },
          {
            key: 'plat_form',
            align: 'center',
            width: 72,
            resizable: true,
            render: (h, params) =>
              h('div', [
                h('span', params.row.platName),
                h('span', { style: 'color:#bbb;' }, `（${params.row.platid}）`)
              ]),
            renderHeader: h =>
              this.renderHeader(h, '所属分组', '显示对应盘口的所属平台')
          },
          {
            key: 'app_name',
            align: 'center',
            width: 72,
            resizable: true,
            render: (h, params) =>
              h('div', [
                h('span', params.row.appName),
                h('span', { style: 'color:#bbb;' }, `（${params.row.app_id}）`)
              ]),
            renderHeader: (h, params) =>
              this.renderHeader(h, '盘口信息', '显示统计信息对应的盘口名称')
          },
          {
            key: 'bill_no',
            align: 'center',
            width: 120,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '流水单号', '每条数据对应的流水单号')
          },
          {
            key: 'user_id',
            align: 'center',
            width: 120,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '玩家ID', '显示该对流水对应的玩家ID')
          },
          {
            key: 'user_name',
            align: 'center',
            width: 120,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '玩家昵称', '显示该对流水对应的玩家昵称')
          },
          {
            key: 'chang_point',
            align: 'center',
            width: 120,
            resizable: true,
            render: (h, params) => {
              let find = this.optType.params.source_list.find(
                item => item.source == params.row.opt_code
              ) || { name: '' }
              this.optTypeModal.opttypename = find.name
              return h('span', find.name)
            },
            renderHeader: (h, params) =>
              this.renderHeader(h, '变更类型', '引起玩家账户余额变动的操作；')
          },
          {
            key: 'game_name',
            align: 'center',
            width: 120,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '所在游戏', '显示此条流水发生所在的游戏；')
          },
          {
            key: 'level',
            align: 'center',
            width: 120,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '所在房间',
                '当一个游戏有多个平行场时，显示该玩家在那一个房间产生的流水'
              )
          },
          {
            key: 'old_point',
            align: 'center',
            width: 120,
            resizable: true,
            render: (h, params) =>
              // h('span', `${this.getCustomFixed(params.row.old_point / 10000)}(${this.getCustomFixed(params.row.old_bank_point / 10000)})`),
              h('span', `${this.getCustomFixed(params.row.old_point / 10000)}`),
            renderHeader: h =>
              this.renderHeader(
                h,
                '玩家账户余额（变动前）',
                '账户发生变动前，该玩家账户的余额；界面信息展示【玩家钱包余额+（玩家钱包余额+玩家银行余额）】'
              )
          },
          {
            key: 'new_point',
            align: 'center',
            width: 120,
            resizable: true,
            render: (h, params) =>
              // h('span',`${this.getCustomFixed(params.row.new_point / 10000)}(${this.getCustomFixed(params.row.new_bank_point / 10000)})`),
              h('span', `${this.getCustomFixed(params.row.new_point / 10000)}`),
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '玩家账户余额（变动后）',
                '账户发生变动后，该玩家账户的余额；界面信息展示【玩家钱包余额+（玩家钱包余额+玩家银行余额）】'
              )
          },
          {
            key: 'chang_point',
            align: 'center',
            width: 120,
            resizable: true,
            sortable: true,
            sortMethod: (val1, val2, desc) => {
              if (desc == 'desc') {
                return val1 > val2 ? -1 : 1
              } else {
                return val1 > val2 ? 1 : -1
              }
            },
            render: (h, params) => {
              let str = params.row.chang_point / 10000
              let color = '#333'
              if (str > 0) {
                color = 'red'
              } else if (str < 0) {
                color = 'blue'
              }
              return h(
                'span',
                { style: { color: color } },
                this.getCustomFixed(str)
              )
            },
            renderHeader: (h, params) =>
              this.renderHeader(h, '变动金额', '玩家账户变动的金额；')
          },
          {
            key: 'bet_detail',
            align: 'center',
            width: 130,
            resizable: true,
            render: (h, params) => {
              if (params.row.game_id == 1005) {
                let hits = JSON.parse(params.row.opt_detail).hits.hits
                let arr = []
                if (hits.dragon && hits.dragon.bet) {
                  arr.push(
                    h('div', '下注龙：' + this.getMoney(hits.dragon.bet))
                  )
                }
                if (hits.tiger && hits.tiger.bet) {
                  arr.push(h('div', '下注虎：' + this.getMoney(hits.tiger.bet)))
                }
                if (hits.mix && hits.mix.bet) {
                  arr.push(h('div', '下注和：' + this.getMoney(hits.mix.bet)))
                }
                return h('div', arr)
              }
              if (params.row.game_id == 1007) {
                let hits = JSON.parse(params.row.opt_detail).hits.hits

                let arr = []
                if (hits.b_dealer && hits.b_dealer.bet) {
                  arr.push(
                    h('div', '下注庄：' + this.getMoney(hits.b_dealer.bet))
                  )
                }
                if (hits.b_player && hits.b_player.bet) {
                  arr.push(
                    h('div', '下注闲：' + this.getMoney(hits.b_player.bet))
                  )
                }
                if (hits.b_dealer_pair && hits.b_dealer_pair.bet) {
                  arr.push(
                    h(
                      'div',
                      '下注庄对：' + this.getMoney(hits.b_dealer_pair.bet)
                    )
                  )
                }
                if (hits.b_player_pair && hits.b_player_pair.bet) {
                  arr.push(
                    h(
                      'div',
                      '下注闲对：' + this.getMoney(hits.b_player_pair.bet)
                    )
                  )
                }
                if (hits.b_mix && hits.b_mix.bet) {
                  arr.push(h('div', '下注和：' + this.getMoney(hits.b_mix.bet)))
                }
                return h('div', arr)
              }
              if (params.row.game_id == 1006) {
                let hits = JSON.parse(params.row.opt_detail).hits.hits
                console.log('1006 hits', hits)
                let arr = []
                if (hits.red && hits.red.bet) {
                  arr.push(h('div', '下注红：' + this.getMoney(hits.red.bet)))
                }
                if (hits.black && hits.black.bet) {
                  arr.push(h('div', '下注黑：' + this.getMoney(hits.black.bet)))
                }
                if (hits.luck && hits.luck.bet) {
                  arr.push(
                    h('div', '幸运一击：' + this.getMoney(hits.luck.bet))
                  )
                }
                return h('div', arr)
              }
              return h('span', '')
            },
            renderHeader: (h, params) =>
              this.renderHeader(h, '下注详情', '龙虎红黑百家乐下注详情；')
          },
          {
            key: 'ip',
            align: 'center',
            width: 120,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '用户所在IP',
                '显示发生此笔流水时用户所在的IP地址'
              )
          },
          {
            key: 'opt_source',
            align: 'center',
            width: 120,
            resizable: true,
            render: (h, params) => {
              let str = ''
              if (params.row.opt_source == '活动领取 5') {
                str = '大转盘'
              } else if (params.row.opt_source == '活动领取 4') {
                str = '转入返利送'
              } else {
                str = params.row.opt_source
              }
              return h('span', str)
            },
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '扩展信息',
                '扩展信息支持模糊查询，查询扩展信息统计项中的数据；'
              )
          },
          {
            key: 'time',
            align: 'center',
            width: 130,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '变更时间', '玩家账户余额发生变动的时间；')
          },
          {
            key: 'pack_no',
            align: 'center',
            width: 120,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '所属子商户', '变动账户玩家所属的子商户；')
          },
          {
            key: 'pack_no',
            title: '变更详情',
            align: 'center',
            fixed: 'right',
            width: 115,
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: { type: 'primary' },
                    style: { margin: '2px', padding: '3px 8px' },
                    on: {
                      click: () => {
                        this.optTypeModal.list = []
                        let find = this.optType.params.source_list.find(
                          item => item.source == params.row.opt_code
                        ) || { name: '' }
                        let str = find.name
                        this.optTypeModal.sourcenum =
                          params.row.opt_code +
                          '/' +
                          params.row.game_id +
                          '/' +
                          new Date()
                        if (
                          params.row.opt_code == 3 ||
                          params.row.opt_code == 4 ||
                          params.row.opt_code == 15 ||
                          params.row.opt_code == 16
                        ) {
                          this.optTypeModal.list.push(params.row)
                          this.optTypeModal.opttypename =
                            str + '(' + params.row.game_name + ')'
                          this.optTypeModal.game_id = params.row.game_id
                          let arr = [
                            2003,
                            3001,
                            1007,
                            1005,
                            1006,
                            1002,
                            1001,
                            1015,
                            1009,
                            1010,
                            1014,
                            2001,
                            2002,
                            5001,
                            5002,
                            6001,
                            0,
                            2008,
                            1016,
                            2006,
                            2005,
                            3002,
                            4001,
                            4002,
                            2004,
                            1018,
                            1017,
                            3003,
                            5003,
                            2009,
                            2101,
                            3004,
                            2010,
                            5004,
                            5005,
                            1019,
                            1020,
                            3005,
                            2102,
                            2011,
                            3006,
                            1021,
                            1022,
                            2013
                          ]
                          if (arr.includes(params.row.game_id)) {
                            this.optTypeModal.show = true
                          } else {
                            this.$Modal.info({
                              title: '详情',
                              content:
                                '<p style="word-wrap:break-word;word-break:break-all;">' +
                                params.row.opt_detail +
                                '</p>'
                            })
                          }
                        } else {
                          this.optTypeModal.list.push(params.row)
                          this.optTypeModal.opttypename = str
                          this.optTypeModal.show = true
                        }
                      }
                    }
                  },
                  '变更详情'
                )
              ])
            }
          }
        ],
        sum: 0,
        total: 0
      },
      //变更类型
      optType: {
        show: false,
        value: ['1', '2', '3', '4'],
        params: { source_list: [] },
        indeterminate: true,
        checkAll: false,
        checkAllGroup: []
      }
    }
  },
  methods: {
    //变更详情显示宽度
    getTableWidth() {
      if (
        this.optTypeModal.game_id == '2101' ||
        this.optTypeModal.game_id == '5005' ||
        this.optTypeModal.game_id == '1016'
      ) {
        return '1175'
      } else if (this.optTypeModal.game_id == '1019') {
        return '1080'
      } else if (this.optTypeModal.game_id == '2102') {
        return '1300'
      } else {
        return '1000'
      }
    },
    closeTimer() {
      this.loading = false
      clearTimeout(this.TransTopReqTimer)
      this.TransTopReqTimer = null
    },
    openTimer() {
      this.closeTimer()
      this.loading = true
      this.TransTopReqTimer = setTimeout(() => {
        this.loading = false
      }, 6000)
    },
    getTableShowData() {
      if (this.select.bet_type) {
        let arr = this.table.list.filter(
          el => el.opt_code == this.select.bet_type
        )
        this.table.total = arr.length
        this.table.sum = arr.reduce((res, cur) => {
          res += Number(cur.chang_point)
          return res
        }, 0)
        return arr
      } else {
        this.table.sum = this.table.list.reduce((res, cur) => {
          res += Number(cur.chang_point)
          return res
        }, 0)
        this.table.total = this.table.list.length
        return this.table.list
      }
    },
    //获取列表
    getList() {
      if (this.loading) return
      this.openTimer()
      // eG-0101-083-20210514063549
      let list = []
      this.table.list = []
      this.table.sum = 0
      this.table.total = 0
      let paramAppArray = []
      this.app_list.forEach(item => {
        if (
          this.select.type == undefined ||
          this.select.type == null ||
          this.select.type == item.sale_type
        ) {
          paramAppArray.push(item.appid)
        }
      })
      if (paramAppArray) {
        let req_list = []
        this.table.params.stime = this.getSecondResult(
          moment(this.select.dataTime1).format('YYYY-MM-DD') +
            ' ' +
            this.select.dataTime2[0]
        )
        this.table.params.etime = this.getSecondResult(
          moment(this.select.dataTime1).format('YYYY-MM-DD') +
            ' ' +
            this.select.dataTime2[1]
        )
        for (let k = 0, lens = paramAppArray.length; k < lens; k++) {
          let app_id = paramAppArray[k]
          let app = this.app_list.find(el => el.appid == app_id)
          if (app) {
            let appName = app.appName
            let platid = app.platform
            let _param = {
              ...this.table.params,
              app_id,
              platid,
              appName,
              user_id: Number(this.table.params.user_id)
            }
            let param = this.getTransParams('GetUserPointRecord', _param)
            req_list.push(param)
          }
        }
        let max = Math.min(5, req_list.length)
        for (let i = 0; i < max; i++) {
          this.toHttp(req_list, list)
        }
      }
    },
    toHttp(req_list, list) {
      if (req_list.length > 0) {
        let param = req_list.shift()
        let { platid, app_id, appName } = param
        TransTopReq(param)
          .then(res => {
            this.table.sum += res._param.sum || 0
            this.table.total += res._param.total || 0
            param.param._func = 'GetUserPointRecord2'
            TransTopReq(param)
              .then(res => {
                let data = res._param.list || []
                data.forEach(item => {
                  Object.assign(item, { platid, app_id, appName })
                  let find = this.plat_list.find(
                    item => item.id == param.platid
                  ) || { name: '' }
                  item.platName = find.name
                })
                this.table.list.push(...data)
                this.requestCallBack(req_list, list)
                this.toHttp(req_list, list)
              })
              .catch(err => {
                this.requestCallBack(req_list, list)
                this.toHttp(req_list, list)
              })
          })
          .catch(error => {
            this.requestCallBack(req_list, list)
            this.toHttp(req_list, list)
          })
      }
    },
    requestCallBack(req_list) {
      if (req_list.length == 0) {
        this.closeTimer()
      }
    },
    getTransParams(_func, _param = {}) {
      return {
        mod: 'root',
        platid: _param.platid,
        app_id: _param.app_id,
        appName: _param.appName,
        param: { _mod: 'manager', _func, _param }
      }
    },
    getSourceTypelist() {
      let platid = this.getinitPlatId() || 14
      let app_id =
        this.app_list.find(item => item.platform == platid).appid || 9001
      let param = this.getTransParams('GetSourceType', { platid, app_id })
      TransTopReq(param).then(res => {
        let data = res._param || {}
        this.optType.params = data
        this.table.params.source_type =
          data.source_list.map(item => item.source) || []
      })
    },
    widthResize(val1, val2, val3) {
      this.tableSetting[val3.key] = val1
      setTableSetting(tableSettingModel.userPointRecord, this.tableSetting)
    },
    initTableSetting() {
      this.tableSetting = getTableSetting(tableSettingModel.userPointRecord)
      this.table.columns.forEach(element => {
        if (element.key && this.tableSetting[element.key]) {
          element.width = this.tableSetting[element.key]
        }
      })
    }
  },
  created() {
    this.initTableSetting()
    this.getSourceTypelist()
  }
}
</script>
<style lang="less"></style>
